var _rect, _rect2, _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoErp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 35,
    viewBox: "0 0 110 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs836"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -11.99259,
    y: -60.736665,
    width: 211.61118,
    height: 76.597832,
    id: "rect1601"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.605732,
    y: -74.663543,
    width: 103.29102,
    height: 46.422929,
    id: "rect1595"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Logo_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 58,
    id: "rect833",
    x: 0,
    y: 0
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    id: "mask1695"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 12.285429,29.4593 4.032672,2.282089 6.0015,-3.504199 -1.99397,-17.49548 -6.818092,-2.0582918 -1.801005,11.9638208 z",
    id: "path1697"
  }))), /*#__PURE__*/React.createElement("g", {
    "aria-label": "ERPSPACE",
    id: "ERPSPACE",
    style: {
      fontWeight: 700,
      fontSize: 15,
      fontFamily: "FiraSans-Bold, 'Fira Sans'",
      fill: "#2d2d2d"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "ERPSPACE",
    transform: "matrix(0.69479969,0,0,0.69479969,44.209362,51.646736)",
    id: "text1599",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "21.3333px",
      lineHeight: 1.25,
      fontFamily: "'Fira Sans'",
      InkscapeFontSpecification: "'Fira Sans'",
      whiteSpace: "pre",
      shapeInside: "url(#rect1601)",
      fill: "#2d2d2d",
      fillOpacity: 1,
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -1.4322042,-56.274113 -0.4053327,2.794662 h -5.055992 v 3.157329 h 4.415993 v 2.709329 h -4.415993 v 3.370661 h 5.3973248 v 2.794662 h -9.3439849 v -14.826643 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 800,
      fontStretch: "normal",
      fontFamily: "'Fira Sans'",
      InkscapeFontSpecification: "'Fira Sans Ultra-Bold'",
      fill: "#2d2d2d",
      fillOpacity: 1
    },
    id: "path1614"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.3611183,-46.908794 H 4.27312 v 5.461324 H 0.32645955 V -56.274113 H 5.4677848 q 3.135995,0 4.6719922,1.130665 1.557331,1.130665 1.557331,3.477328 0,1.407998 -0.661332,2.346663 -0.639999,0.938665 -2.0693301,1.68533 l 3.6906611,6.186657 H 8.262447 Z M 4.27312,-49.59679 h 1.3226646 q 2.0479967,0 2.0479967,-2.06933 0,-0.959999 -0.5759991,-1.407998 -0.5546658,-0.447999 -1.6853306,-0.447999 H 4.27312 Z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 800,
      fontStretch: "normal",
      fontFamily: "'Fira Sans'",
      InkscapeFontSpecification: "'Fira Sans Ultra-Bold'",
      fill: "#2d2d2d",
      fillOpacity: 1
    },
    id: "path1616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18.612098,-56.274113 q 2.986662,0 4.629326,1.258665 1.663997,1.237331 1.663997,3.647994 0,2.517329 -1.599997,3.839994 -1.599998,1.301331 -4.309327,1.301331 h -1.514664 v 4.778659 h -3.94666 v -14.826643 z m 0.02133,7.231989 q 1.109332,0 1.663998,-0.554666 0.575999,-0.554666 0.575999,-1.749331 0,-2.154663 -2.32533,-2.154663 h -1.066665 v 4.45866 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 800,
      fontStretch: "normal",
      fontFamily: "'Fira Sans'",
      InkscapeFontSpecification: "'Fira Sans Ultra-Bold'",
      fill: "#2d2d2d",
      fillOpacity: 1
    },
    id: "path1618"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 31.05941,-56.402113 q 1.471998,0 2.51733,0.426666 1.045331,0.405333 2.026663,1.279998 l -1.109331,1.237332 q -0.831999,-0.661333 -1.642665,-0.959999 -0.789332,-0.319999 -1.706663,-0.319999 -1.151999,0 -1.898664,0.533332 -0.746666,0.533333 -0.746666,1.557331 0,0.639999 0.256,1.087998 0.256,0.426666 0.938665,0.789332 0.703999,0.362666 2.026664,0.767999 1.386664,0.426666 2.303996,0.917332 0.917332,0.490666 1.471998,1.365331 0.575999,0.853332 0.575999,2.175997 0,1.279998 -0.639999,2.26133 -0.618666,0.981331 -1.813331,1.535997 -1.173331,0.554666 -2.794662,0.554666 -3.050662,0 -4.991992,-1.898664 l 1.109331,-1.237331 q 0.895999,0.725332 1.813331,1.109331 0.917332,0.362667 2.047997,0.362667 1.365331,0 2.261329,-0.661333 0.895999,-0.682665 0.895999,-1.962663 0,-0.725333 -0.277333,-1.194665 -0.277333,-0.490666 -0.959998,-0.874665 -0.661333,-0.384 -1.941331,-0.767999 -2.261329,-0.682666 -3.306661,-1.642664 -1.045332,-0.959999 -1.045332,-2.602663 0,-1.109331 0.575999,-1.983997 0.597333,-0.874665 1.642664,-1.365331 1.066665,-0.490666 2.410663,-0.490666 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "21.3333px",
      lineHeight: 1.25,
      fontFamily: "'Fira Sans'",
      InkscapeFontSpecification: "'Fira Sans'",
      whiteSpace: "pre",
      shapeInside: "url(#rect1601)",
      fill: "#2d2d2d",
      fillOpacity: 1,
      stroke: "none"
    },
    id: "path1620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.919058,-56.146113 q 2.730662,0 4.223993,1.151998 1.493331,1.130665 1.493331,3.391995 0,2.410663 -1.557331,3.583994 -1.557331,1.173331 -4.13866,1.173331 h -1.855997 v 5.397325 H 39.05773 v -14.698643 z m -0.064,7.701321 q 1.770663,0 2.687995,-0.682666 0.938666,-0.682665 0.938666,-2.453329 0,-1.578664 -0.938666,-2.282663 -0.917332,-0.703999 -2.645329,-0.703999 h -1.81333 v 6.122657 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "21.3333px",
      lineHeight: 1.25,
      fontFamily: "'Fira Sans'",
      InkscapeFontSpecification: "'Fira Sans'",
      whiteSpace: "pre",
      shapeInside: "url(#rect1601)",
      fill: "#2d2d2d",
      fillOpacity: 1,
      stroke: "none"
    },
    id: "path1622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 57.970368,-41.44747 -1.109332,-3.690661 h -5.567991 l -1.109331,3.690661 h -2.047997 l 4.714659,-14.698643 h 2.559996 l 4.693326,14.698643 z m -6.186657,-5.333325 h 4.58666 l -2.282663,-7.679987 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "21.3333px",
      lineHeight: 1.25,
      fontFamily: "'Fira Sans'",
      InkscapeFontSpecification: "'Fira Sans'",
      whiteSpace: "pre",
      shapeInside: "url(#rect1601)",
      fill: "#2d2d2d",
      fillOpacity: 1,
      stroke: "none"
    },
    id: "path1624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 67.282353,-56.402113 q 1.322665,0 2.218663,0.341333 0.917332,0.341333 1.855997,1.109332 l -1.109331,1.301331 q -1.343998,-1.087998 -2.837329,-1.087998 -1.834664,0 -2.965329,1.407997 -1.109331,1.407998 -1.109331,4.52266 0,3.029328 1.109331,4.479993 1.109332,1.429331 2.943996,1.429331 0.938665,0 1.642664,-0.32 0.703999,-0.319999 1.493331,-0.895998 l 1.002665,1.279998 q -0.682666,0.703999 -1.749331,1.173331 -1.066665,0.469333 -2.453329,0.469333 -1.791997,0 -3.199995,-0.874665 -1.386665,-0.895999 -2.175997,-2.602663 -0.767998,-1.727997 -0.767998,-4.13866 0,-2.410663 0.810665,-4.117327 0.810665,-1.727997 2.19733,-2.602662 1.386664,-0.874666 3.093328,-0.874666 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "21.3333px",
      lineHeight: 1.25,
      fontFamily: "'Fira Sans'",
      InkscapeFontSpecification: "'Fira Sans'",
      whiteSpace: "pre",
      shapeInside: "url(#rect1601)",
      fill: "#2d2d2d",
      fillOpacity: 1,
      stroke: "none"
    },
    id: "path1626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 82.056662,-56.146113 -0.234667,1.621331 h -5.695991 v 4.799992 h 4.949326 v 1.621331 h -4.949326 v 5.034659 h 6.101324 v 1.62133 h -8.127987 v -14.698643 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "21.3333px",
      lineHeight: 1.25,
      fontFamily: "'Fira Sans'",
      InkscapeFontSpecification: "'Fira Sans'",
      whiteSpace: "pre",
      shapeInside: "url(#rect1601)",
      fill: "#2d2d2d",
      fillOpacity: 1,
      stroke: "none"
    },
    id: "path1628"
  })), /*#__PURE__*/React.createElement("text", {
    id: "text1593",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "21.33333332999999854px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      whiteSpace: "pre",
      shapeInside: "url(#rect1595)",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1497",
    style: {
      fill: "#cce0ff",
      fillOpacity: 1
    },
    transform: "matrix(0.34804938,0,0,0.34804938,-1.7670756,-1.3232674)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cce0ff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.26458300000000001px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 25.980762,69.999999 51.961524,84.999998 82.272413,67.499999 77.942286,65 73.612158,67.499999 51.961524,80 25.980762,64.999999 Z",
    id: "path939-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cce0ff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.26458300000000001px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 25.980762,50 v 5 L 51.961524,69.999999 73.612158,57.5 69.282033,55 51.961524,64.999999 Z",
    id: "path941-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cce0ff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.26458300000000001px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 86.60254,44.999999 V 50 L 73.612157,57.499998 69.282031,55 Z",
    id: "path1475"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cce0ff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.26458300000000001px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 43.301269,64.999999 25.980762,55 v -5 l 21.650635,12.499999 z",
    id: "path1479"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cce0ff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.26458300000000001px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 51.961523,79.999998 43.301269,75 V 59.999998 l 8.660254,5.000001 v 14.999999",
    id: "path1483"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cce0ff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.26458300000000001px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 77.942286,64.999999 v 5 l -4.330129,-2.5 z",
    id: "path1487"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path935-9",
    style: {
      fill: "#0052cc",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.092088px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 4.2612196,10.858443 v 13.922024 l 12.0568814,6.960922 9.042616,-5.220781 1.507042,-0.869981 1.507044,-0.87016 v -8.701243 l -3.014086,1.740142 -9.042616,5.220781 -9.0426162,-5.220781 v -1.740142 l 9.0426162,5.220782 12.056702,-6.961102 v -3.480461 l -12.056702,6.960923 z m 3.0142652,10.441563 9.0426162,5.220602 9.042616,-5.220602 v 1.740141 l -9.042616,5.220782 -9.0426162,-5.220782 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cce0ff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0920879,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 4.2613165,10.858461 16.318101,3.8974733 28.374884,10.858461 16.318101,17.819449 Z",
    id: "path937-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052cc",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.0920879px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 16.3181,17.819449 v 8.701233 l 3.014196,-1.740246 v -8.701234 z",
    id: "path1469"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cce0ff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.101818px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 16.3181,23.427374 v 4.254864 l -3.014196,-2.127431 v -4.254865 z",
    id: "path1473"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cce0ff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.09208790000000000px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 13.303904,24.780436 16.3181,23.040189 v -1.740247 l -1.507097,-0.870123 -1.507099,0.870123 z",
    id: "path1477"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cce0ff",
      fillOpacity: 1,
      stroke: "#cce0ff",
      strokeWidth: "1.09041px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 16.318156,31.939964 V 15.386837",
    id: "path1679",
    mask: "url(#mask1695)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoErp);
export default __webpack_public_path__ + "static/media/LogoErp.c4d8b04a.svg";
export { ForwardRef as ReactComponent };